import { AssignmentMode, ImportRow, ImportStats } from "src/core/utils/import/types";

const percent = (count: number, total: number) =>
  total === 0 ? 0 : Math.round((count / total) * 100);

export const computeImportStats = (rows: ImportRow[]): ImportStats => {
  const total = rows.length;
  const created = rows.filter((row) => row.status === "created").length;
  const existing = rows.filter((row) => row.status === "existing").length;
  const error = rows.filter((row) => row.status === "error").length;

  return {
    total,
    created,
    existing,
    error,
    createdPct: percent(created, total),
    existingPct: percent(existing, total),
    errorPct: percent(error, total),
  };
};

const escapeCsv = (value: string) => {
  if (/[;"\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const stepValue = (value: boolean | null) => {
  if (value === null) return "";
  return value ? "OK" : "KO";
};

export type ImportReportLabels = {
  status: (row: ImportRow) => string;
  message: (row: ImportRow) => string;
};

export const buildImportReportCsv = (
  rows: ImportRow[],
  mode: AssignmentMode,
  labels: ImportReportLabels
) => {
  const headers = [
    "Siren",
    "etat",
    "existant",
    "creation auto",
    "creation folder",
    "call E-reputation",
  ];

  if (mode === "with") {
    headers.push("call Follow Folder");
  }

  headers.push("message");

  const lines = rows.map((row) => {
    const cells = [
      row.siren,
      labels.status(row),
      row.existant === null ? "" : row.existant ? "Y" : "N",
      stepValue(row.creationAuto),
      stepValue(row.creationFolder),
      stepValue(row.callEReputation),
    ];

    if (mode === "with") {
      cells.push(stepValue(row.callFollowFolder));
    }

    cells.push(labels.message(row));
    return cells.map(escapeCsv).join(";");
  });

  return [headers.join(";"), ...lines].join("\n");
};

export const downloadTextFile = (filename: string, content: string) => {
  const blob = new Blob([`\uFEFF${content}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
